/**
 * Authentication Provider Types
 * Defines all available authentication methods
 */
export const AuthProviders = {
    PASSWORD: 'password',
    EMAIL_TOKEN: 'email_token',
    MAGIC_LINK: 'magic_link',
    GOOGLE: 'google',
    FACEBOOK: 'facebook',
    APPLE: 'apple',
    JWT: 'jwt',
    SSO: 'sso',
    IBI: 'ibi'
}

/**
 * Social login providers subset
 */
export const SocialProviders = [
    AuthProviders.GOOGLE,
    AuthProviders.FACEBOOK,
    AuthProviders.APPLE
]

/**
 * Provider priority order
 * Used to determine default/primary provider when multiple are enabled
 *
 * JWT and SSO are at the top because they're auto-detected from URL params,
 * and when present should take absolute priority (transparent auto-login)
 */
export const ProviderPriority = [
    AuthProviders.JWT,            // Auto-login via ?jwt=xxx (highest priority)
    AuthProviders.SSO,            // Enterprise SSO via ?t=xxx&k=yyy
    AuthProviders.MAGIC_LINK,     // Passwordless via email link (higher priority than token)
    AuthProviders.EMAIL_TOKEN,    // Passwordless (best UX for manual login)
    AuthProviders.PASSWORD,       // Traditional email/password
    AuthProviders.GOOGLE,         // Social login
    AuthProviders.FACEBOOK,
    AuthProviders.APPLE,
    AuthProviders.IBI             // Special integration
]

/**
 * OAuth backend identifiers for social login convert-token endpoint
 */
export const OAuthBackends = {
    [AuthProviders.GOOGLE]: 'google-oauth2',
    [AuthProviders.FACEBOOK]: 'facebook',
    [AuthProviders.APPLE]: 'apple-id'
}
